/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import moment from 'moment'

import { API } from '../api/api'
import { fetch, post, put } from '../api/httpClient'
import {
  ALL_ENROLLED,
  COURSE_STATUS,
  DATEFORMAT,
  DATEFORMATWITHTIME,
  DEFAULTURL,
  DOC_TYPE_TRANSCRIPT,
  DROP_ENROLLMENT_LOCK_STATUSES,
  ENROLLMENTTYPES,
  LOCK_COURSES_ENROLLMENT_STATUSES,
  LOCK_COURSES_HOLD_STATUSES,
  LOCK_TRANSCRIPT_ENROLLMENT_STATUSES,
  LOCK_TRANSCRIPT_HOLD_STATUSES,
  MESSAGE_SEVERITIES,
  PRIOR,
  PROGRAM_META_KEYS,
} from '../helpers/constants'
import {
  selectApp,
  selectEnrolledPrograms,
  selectPriorPrograms,
  selectSchool,
  selectUser,
} from '../helpers/selectors'
import {
  formatDate,
  get,
  getFullName,
  getPercentage,
  isEmpty,
  isNullOrEmpty,
  set,
} from '../helpers/utils'
import { appAction, enrolledProgramAction, messageAction, priorProgramAction } from './app.action'
import { enrollmentSummaryAction } from './enrollment.summary.action'
import { fetchFilesCall } from './profile.action'

export const fetchProgramsCategory =
  (pageDetails, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.PROGRAMCATEGORY}?schoolId=${pageDetails.schoolId}&page=${
        pageDetails.page || ''
      }&perPage=${pageDetails.perPage || ''}&sortBy=${pageDetails.sort_by || ''}&sortOrder=${
        pageDetails.sort_order || ''
      }`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchPostGradPlans = (id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.POSTGRADPLANQUESTIONS}?pgm_id=${id}&perPage=50`
    const { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}
export const fetchAddOnsPurchaseItemsCall =
  (pageDetails, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.ADD_ONS}?page=${pageDetails.current_page || ''}&perPage=${
        pageDetails.per_page || ''
      }&sortBy=${pageDetails.sort_by || ''}&sortOrder=${pageDetails.sort_order || ''}&schId=${
        pageDetails.schoolId || ''
      }&pgmId=${pageDetails.pgmId || ''}`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchAddOnCheckoutDetail = (id, successCallback, failureCallback) => async () => {
  try {
    const apiPath = `${API.CORE.ADD_ONS_DETAIL}/${id}`
    const { data } = await fetch(apiPath, {})
    modifyAddOnsServiceData(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const editPostGradResponse =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    try {
      const apiPath = API.CORE.UPDATEPOSTGRADPLANQUESTIONRESPONSE
      const updatedPayload = {
        ...payload,
      }
      await put(apiPath, updatedPayload)
      dispatch(
        messageAction({
          subTitle: 'message:updatePostGradResponse',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchPostGradPlanResponse = (id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.POSTGRADPLANQUESTIONRESPONSE}/${id}`
    const { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const fetchAvailableProgramsCall =
  (schoolId, pageDetails, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const user = selectUser(state)
      const url = `${API.CORE.ENROLLMENT}?schoolId=${schoolId}&page=${
        pageDetails.current_page
      }&perPage=${pageDetails.per_page}&programCategory=${pageDetails.programCategory || ''}&age=${
        user.age
      }`
      const { data } = await fetch(url)
      get(data, 'content', []).forEach((item) => modifyEnrollItem(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchAllProgramsCall =
  (schoolId, pageDetails, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.ALLPROGRAMS}?schoolId=${schoolId}&page=${
        pageDetails.current_page || ''
      }&perPage=${pageDetails.per_page || ''}`
      const { data } = await fetch(url)
      // get(data, 'content', []).forEach((item) => modifyEnrollItem(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchEnrolledPrograms =
  (pageDetails = {}, successCallback, failureCallback) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const school = selectSchool(state)
      const url = `${API.CORE.ENROLLMENTPROGRAMS}?&page=${
        pageDetails.current_page || '1'
      }&perPage=${pageDetails.per_page || '100'}&sortBy=${pageDetails.sort_by || ''}&sortOrder=${
        pageDetails.sort_order || ''
      }&schoolId=${school.sch_school_public_id}&status=${ALL_ENROLLED || ''}&isCourseEnable=true`

      const { data } = await fetch(url)
      get(data, 'content', []).forEach((item) => modifyDashboardEnrollment(item))
      // get(data, 'content', []).forEach((item) => {
      //   item.currentCourse = item?.enr_enrollment_course?.filter(
      //     (course) =>
      //       course?.enc_status === COURSE_STATUS.IN_PROGRESS ||
      //       course?.enc_status === COURSE_STATUS.PENDING
      //   )
      //   item.completedCourse = item?.enr_enrollment_course?.filter(
      //     (course) =>
      //       course?.enc_status === COURSE_STATUS.PASSED ||
      //       course?.enc_status === COURSE_STATUS.FAILED ||
      //       course?.enc_status === COURSE_STATUS.PASSED_WITHOUT_GRADE ||
      //       course?.enc_status === COURSE_STATUS.WITHDRAWN ||
      //       course?.enc_status === COURSE_STATUS.IN_COMPLETE
      //   )
      //   item.upComingCourse = item?.enr_enrollment_course?.filter(
      //     (course) => course?.enc_status === COURSE_STATUS.UPCOMING
      //   )
      //   item.isOpenCurrentCourse = item?.currentCourse?.length > 0
      //   item.isOpenUpcomingCourse =
      //     item?.upComingCourse.length > 0 && item?.currentCourse?.length === 0
      // })

      if (!isEmpty(data)) {
        dispatch(enrolledProgramAction({ ...data }))
      }

      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchPriorPrograms =
  (pageDetails = {}, successCallback, failureCallback) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const school = selectSchool(state)
      const url = `${API.CORE.ENROLLMENTPROGRAMS}?&page=${
        pageDetails.current_page || '1'
      }&perPage=${pageDetails.per_page || '100'}&sortBy=${pageDetails.sort_by || ''}&sortOrder=${
        pageDetails.sort_order || ''
      }&schoolId=${school.sch_school_public_id || ''}&status=${PRIOR || ''}`

      const { data } = await fetch(url)
      get(data, 'content', []).forEach((item) => modifyEnrollItem(item))
      if (!isEmpty(data)) {
        dispatch(priorProgramAction({ total: data?.total, content: data.content }))
      }
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchProgramById =
  (params, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const user = selectUser(getState())
      const url = `${API.CORE.ENROLLMENT}/${params.programId}?studentUrn=${encodeURIComponent(
        user.urn
      )}`
      const { data } = await fetch(url)
      modifyProgramItem(data)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchProgramCoursesById =
  (programId, realmName, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.COURSEDETAILOPEN}/${programId}`
      const customHeaders = {
        headers: {
          ['realm-name']: realmName,
        },
      }
      const { data } = await fetch(url, customHeaders)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchProgramByIdOpen = (programId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.PROGRAM}/${programId}`
    const { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const fetchProgramCoursesByIdOpen =
  (programId, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.COURSEDETAILOPEN}/${programId}`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchAttachedProgramCoursesByIdOpen =
  (programId, realmName, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.COURSEDETAILOPEN}/${programId}`
      const customHeaders = {
        headers: {
          ['realm-name']: realmName,
        },
      }
      const { data } = await fetch(url, customHeaders)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchProgramFeeById =
  (programId, enrollmentId, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.ENROLLMENTFEE}?programId=${programId}&enrollmentId=${enrollmentId}`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchReEnrollmentFeeById = (reEnrId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.REENROLLMENTFEE}/${reEnrId}`
    const { data } = await fetch(url)
    const updatedResponse = data.map((item) => ({
      ...item.ref_Fees,
    }))
    if (typeof successCallback === 'function') {
      successCallback(updatedResponse)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const enrollCall = (programId, payload, successCallback, failureCallback) => async () => {
  try {
    const updatedPayload = {
      ...payload,
      program_id: programId,
    }
    const url = API.CORE.ENROLLPROGRAM
    const { data } = await post(url, updatedPayload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchEnrollmentDetailsCall =
  (enrollmentId, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.ENROLLMENTDETAIL}/${enrollmentId}`
      const { data } = await fetch(url)
      modifyEnrollItem(data)
      get(data, 'en_enrollment_drop', []).forEach((item) => modifyDropEnrollment(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }
export const fetchEnrollmentCourse =
  (enrollmentId, pageDetails, successCallback, failureCallback) => async () => {
    try {
      let apiPath = `${API.CORE.ENROLLMENTCOURSES}?page=${pageDetails.page || ''}&perPage=${
        pageDetails.perPage || ''
      }&sortBy=${pageDetails.sort_by || ''}&sortOrder=${pageDetails.sort_order || ''}&q=${
        pageDetails.q || ''
      }&enrollmentId=${enrollmentId}`
      if (pageDetails.status) {
        apiPath += `&status=${pageDetails.status || ''}`
      }
      const { data } = await fetch(apiPath)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchEnrollmentSummaryWithProgress =
  (pageDetails, successCallback, failureCallback) => async (dispatch) => {
    try {
      const apiPath = `${API.CORE.SUMMARY}/${pageDetails.enrollmentId}/${pageDetails.programId}?q=${
        pageDetails.q || ''
      }&encStatus=${pageDetails.encStatus || ''}&encState=${pageDetails.encState || ''}`
      const { data } = await fetch(apiPath)
      const summary = []
      data.forEach((item) => {
        modifyCourses(item)
        const group = summary.find(
          (cgItem) => cgItem.cg_course_group_name === item.cg_course_group_name
        )
        if (!group) {
          summary.push({
            cg_course_group_name: item.cg_course_group_name,
            cgi_course_group_id: item.cgi_course_group_id,
            courses: [item],
          })
        } else {
          group.courses.push(item)
        }
      })
      if (!isEmpty(summary)) {
        dispatch(
          enrollmentSummaryAction({
            id: pageDetails.enrollmentId.toString(),
            summary,
          })
        )
      }
      if (typeof successCallback === 'function') {
        successCallback(summary)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const syncGradesCall = (pageDetails, successCallback, failureCallback) => async () => {
  try {
    const apiPath = `${API.CORE.GRADE_FETCH}?enrollmentId=${pageDetails.enrollmentId}`
    await fetch(apiPath)
    if (typeof successCallback === 'function') {
      successCallback()
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchEnrollmentSummary =
  (pageDetails, successCallback, failureCallback) => async () => {
    try {
      const apiPath = `${API.CORE.SUMMARYWITHPROGRESS}/${pageDetails.enrollmentId}/${
        pageDetails.programId
      }?q=${pageDetails.q || ''}&encStatus=${pageDetails.encStatus || ''}&encState=${
        pageDetails.encState || ''
      }`
      const { data } = await fetch(apiPath)
      const summary = []
      data.forEach((item) => {
        const group = summary.find(
          (cgItem) => cgItem.cg_course_group_name === item.cg_course_group_name
        )
        if (!group) {
          summary.push({
            cg_course_group_name: item.cg_course_group_name,
            cgi_course_group_id: item.cgi_course_group_id,
            courses: [item],
          })
        } else {
          group.courses.push(item)
        }
      })
      if (typeof successCallback === 'function') {
        successCallback(summary)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }
export const fetchEnrollmentCourseById =
  (courseId, successCallback, failureCallback) => async () => {
    try {
      const apiPath = `${API.CORE.ENROLLMENTCOURSES}/${courseId}`
      const { data } = await fetch(apiPath)
      modifySuccessCoach(data)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchAdminUserDetails =
  (id, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      if (isEmpty(id)) {
        return
      }
      const state = getState()
      const app = selectApp(state)
      const school = selectSchool(state)
      const url = `${API.CORE.ADMINUSERDETAIL}/${id}`
      const { data } = await fetch(url)
      data.avatar_full = [
        `${app.baseURL}${API.MEDIAMANAGER.MEDIA}/api/access/${school.sch_tenant_id}/${DEFAULTURL.DEFAULT}${data?.avatar}`,
      ]
      modifySuccessCoach(data)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const updateEnrollmentCourses =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    try {
      const url = API.CORE.UPDATEENROLLPROGRAM
      const { data } = await put(url, payload)
      dispatch(
        messageAction({
          subTitle: 'message:updateEnrollmentCourses',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchPriorCoachCall = (enrollmentId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.PRIORCOACHES}?enrollmentId=${enrollmentId}`
    const { data } = await fetch(url)
    data.forEach((item) => modifySuccessCoach(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchTemplatesCall =
  (schoolId, templateName, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.TEMPLATES}?schoolId=${schoolId}&templateName=${templateName}`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }
export const fetchPublicTemplatesCall =
  (schoolId, templateName, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.PUBLIC_TEMPLATES}/guest/?schoolId=${schoolId}&templateName=${templateName}`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const subscriptionVerifyCall =
  (appId, invoiceId, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.SUBSCRIPTION_VERIFY}?appId=${appId}&invoiceId=${invoiceId}`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const dropEnrollmentCall =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    const updatedPayload = {
      ...payload,
      end_request_type: payload.end_request_type.join(','),
      end_reason: payload.end_reason.join(','),
    }
    try {
      await post(API.CORE.DROPENROLLMENT, updatedPayload)
      dispatch(
        messageAction({
          subTitle: 'message:dropEnrolledStatusUpdate',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const downloadTranscriptCall =
  (enrollmentId, transcriptId, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const app = selectApp(state)
      const school = selectSchool(state)
      const url = `${app.baseURL}${API.CORE.DOWNLOADTRANSCRIPT}?enrollmentId=${enrollmentId}&transcriptId=${transcriptId}&tenantId=${school.sch_tenant_id}&realmName=${school.sch_school_public_id}`
      window.open(url)
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const downloadEnrollmentAgreementCall =
  (enrollmentId, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const app = selectApp(state)
      const school = selectSchool(state)
      const url = `${app.baseURL}${API.CORE.DOWNLOADENROLLMENTAGREEMENT}?id=${enrollmentId}&tenantId=${school.sch_tenant_id}&realmName=${school.sch_school_public_id}`
      window.open(url)
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const downloadEnrollmentDropRequestCall =
  (enrollmentId, successCallback, failureCallback) => async (dispatch, getState) => {
    try {
      const state = getState()
      const app = selectApp(state)
      const school = selectSchool(state)
      const url = `${app.baseURL}${API.CORE.DOWNLOADENROLLMENDROPPDF}?id=${enrollmentId}&tenantId=${school.sch_tenant_id}&realmName=${school.sch_school_public_id}`
      window.open(url)
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchQuizzesCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const updatedPayload = {
      ...payload,
      include: ['submission', 'assignments'],
    }
    const apiPath = API.CORE.QUIZZES
    const { data } = await post(apiPath, updatedPayload)
    get(data, 'items', []).forEach((item) =>
      get(item, 'submission', []).forEach((submissions) => modifyQuizSubmissons(submissions))
    )
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const transcriptMessageAction = () => async (dispatch, getState) => {
  const state = getState()
  const user = selectUser(state)
  const enrolledPrograms = selectEnrolledPrograms(state)

  const filterData = {
    sort_by: '',
    sort_order: '',
    q: DOC_TYPE_TRANSCRIPT,
    current_page: 1,
    per_page: 200,
  }
  dispatch(
    fetchFilesCall(
      user.urn,
      filterData,
      (records) => {
        dispatch(
          appAction({
            showTranscriptMessage:
              enrolledPrograms?.content.findIndex(
                (item) => item?.enr_program?.pgm_require_transcript
              ) !== -1 &&
              records?.content.findIndex(
                (file) => file.fl_file_name === DOC_TYPE_TRANSCRIPT && file.fl_status === 'verified'
              ) === -1,
          })
        )
      },
      null,
      { showLoader: false }
    )
  )
}

export const fetchAdditionalFee =
  (enrollmentId, pageDetails, successCallback, failureCallback) => async () => {
    try {
      const apiPath = `${API.CORE.ADDITIONALFEE}?page=${pageDetails.current_page || '1'}&perPage=${
        pageDetails.per_page || '10'
      }&sortBy=${pageDetails.sort_by || ''}&sortOrder=${pageDetails.sort_order || ''}&q=${
        pageDetails.q || ''
      }&enrollmentId=${enrollmentId}`
      const { data } = await fetch(apiPath, {})
      get(data, 'content', []).forEach((item) => modifyAdditionalFee(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchAdditionalFeeDetail = (id, successCallback, failureCallback) => async () => {
  try {
    const apiPath = `${API.CORE.ADDITIONALFEE}/${id}`
    const { data } = await fetch(apiPath, {})
    modifyAdditionalFee(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const fetchReEnrollmentListCall =
  (enrollmentId, successCallback, failureCallback) => async () => {
    //
    try {
      const filterQuery = `enrollmentId=${enrollmentId || ''}`
      const pageQuery = `page=${1}&perPage=${20}&sortOrder=desc&sortBy=created_at`

      const apiPath = `${API.CORE.REENROLLMENTS}?${pageQuery}&${filterQuery}`

      const { data } = await fetch(apiPath, {})
      get(data, 'content', []).forEach((item) => modifyReEnrollment(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    } finally {
      //
    }
  }

export const fetchReEnrollmentDetailCall =
  (enrollmentId, successCallback, failureCallback) => async () => {
    try {
      const apiPath = `${API.CORE.REENROLLMENTS}/${enrollmentId}`

      const { data } = await fetch(apiPath, {})
      modifyReEnrollment(data)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchReEnrollmentElectiveCoursesCall =
  (id, pgm_id, successCallback, failureCallback) => async () => {
    try {
      const pageQuery = `elective-course-list?pgmId=${pgm_id || ''}&reEnrRequestId=${id || ''}`
      const apiPath = `${API.CORE.REENR}/${pageQuery}`
      const { data } = await fetch(apiPath, {})
      data.forEach((item) => modifyReEnrollmentElective(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const assignReEnrollmentCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.REENROLLMENTS}`
    const { data } = await post(url, payload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const acceptReEnrollTnC = (id, payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.REENROLLMENTS}/${id}`
    const { data } = await put(url, payload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchSchoolStoresCall = (schoolId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.SCHOOL_STORES}/${schoolId}?page=1&perPage=1000`
    const { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}
export const fetchGuestSchoolStoresCall =
  (schoolId, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.CORE.GUEST_SCHOOL_STORES}/${schoolId}?page=1&perPage=1000`
      const { data } = await fetch(url)
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const schoolStoresAddOnCall =
  (appId, payload, successCallback, failureCallback) => async () => {
    try {
      const url = API.CORE.SCHOOL_STORES_ADDON
      const customHeaders = {
        headers: {
          ['Application-Id']: appId,
        },
      }
      const { data } = await post(url, payload, customHeaders)
      if (typeof successCallback === 'function') {
        successCallback(get(data, 'approval_url', ''))
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const guestCheckoutCall =
  (appId, payload, studentInfo, successCallback, failureCallback) => async () => {
    const updatedPayload = {
      userDetails: {
        ...studentInfo,
        email: studentInfo?.email?.toLowerCase()?.trim(),
        dob: `${moment(studentInfo?.dob).format(DATEFORMAT)}`,
      },
      add_fee_guest_remark: studentInfo.add_fee_guest_remark,
      ...payload,
    }
    try {
      const url = API.CORE.GUEST_CHECKOUT
      const customHeaders = {
        headers: {
          ['Application-Id']: appId,
        },
      }
      const { data } = await post(url, updatedPayload, customHeaders)
      if (typeof successCallback === 'function') {
        successCallback(get(data, 'approval_url', ''))
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const fetchProgramMetadata = (id, successCallback, failureCallback) => async () => {
  try {
    const metaKeys = `metaKeys=${PROGRAM_META_KEYS.EXTENSION_FEE_DAYS}&metaKeys=${PROGRAM_META_KEYS.ENABLE_EXTENSION_FEE}&metaKeys=${PROGRAM_META_KEYS.ENABLE_AUTO_APPROVE}&metaKeys=${PROGRAM_META_KEYS.HIDE_REQUIRED_CREDITS}&metaKeys=${PROGRAM_META_KEYS.SKIP_PSM_GATEWAYS}&metaKeys=${PROGRAM_META_KEYS.ENABLE_INVOICE}`
    const url = `${API.CORE.METADATA}?metaType=program&metaTypeId=${id}&${metaKeys}`
    let { data } = await fetch(url)
    data = data.reduce((value, currentItem) => {
      value[currentItem.md_meta_key] = checkForTypes(
        currentItem.md_meta_key,
        currentItem.md_meta_value
      )
      return value
    }, {})
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchPendingEnrollents = (successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.PENDING_ENROLLMENTS}`
    const { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data?.data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchEnrolledProgramWithStatus =
  (successCallback, failureCallback) => async (_, getState) => {
    try {
      const state = getState()
      const user = selectUser(state)
      const enrolledPrograms = selectEnrolledPrograms(state)
      const priorPrograms = selectPriorPrograms(state)
      const url = `${API.CORE.ENROLLMENTS_WITH_STATUS}?userUrn=${user.urn}`

      const { data } = await fetch(url)
      const allEnrollments = [...enrolledPrograms.content, ...priorPrograms.content]
      data.expired.forEach((item) => modifyStatusEnrollments(item))
      data.completed.forEach((item) => modifyStatusEnrollments(item))
      const updatedData = {
        ...data,
        declined_payment: modifyPaymentDetails(
          data?.declined_payment?.filter((row) => isNullOrEmpty(row.late_additional_fee)),
          allEnrollments
        ),
        late_fee: modifyPaymentDetails(data.late_fee, allEnrollments),
      }
      if (typeof successCallback === 'function') {
        successCallback(updatedData)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchDistinctionCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${
      API.CORE.DISTINCTIONS_EARNED
    }?page=1&limit=50&sortBy=&sortOrder=desc&q=&dist_earned_enr_id=${payload.enr_id || ''}`
    const { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const concludeCourseCall =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    try {
      const url = API.CORE.CONCLUDE_COURSE
      await put(url, payload)
      dispatch(
        messageAction({
          subTitle: 'message:courseConclude',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

const modifyPaymentDetails = (data, enrollments) => {
  const updatedFeeDetails = data?.map((item) => {
    const programDetails = (enrollments || [])?.find((elem) => elem.enr_id === item.enr_id)
    const updatedData = { ...item, dueAmount: programDetails?.dueAmount }
    modifyStatusEnrollments(updatedData)
    return updatedData
  })
  return updatedFeeDetails
}

export const loginAsAddOnProgramCall = (aopEnrId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.INTERNAL_SSO}/${aopEnrId}`
    const { data } = await fetch(url, {})
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchLMSEnrollmentDetails = (sisId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.ENROLLMENT_DETAILS}?sis_id=LS-${sisId}`
    const { data } = await fetch(url, {})
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}
const modifyStatusEnrollments = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.enr_enrolled_on = formatDate(item.enr_enrolled_on, DATEFORMAT)
  item.enr_end_date = formatDate(item.enr_end_date, DATEFORMAT)
  if (item.enr_status === ENROLLMENTTYPES.COMPLETED) {
    const programGradeLevel = sortGradeLevelArray(JSON.parse(item?.pgm_grade_level || '{}'))
    item.pgm_grade_level = sortGradeLevelArray(JSON.parse(item?.pgm_grade_level || '{}'))
    const currentIndex = programGradeLevel?.indexOf(item?.enr_current_grade)
    if (currentIndex !== -1 && currentIndex < programGradeLevel?.length) {
      const nextGrade = programGradeLevel[currentIndex + 1]
      set(item, 'next_grade', nextGrade)
    } else {
      set(item, 'next_grade', null)
    }
  }
}

const modifyAdditionalFee = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.id = item.add_fee_id
  item.created_at = formatDate(item.created_at, DATEFORMATWITHTIME)
  item.updated_at = formatDate(item.updated_at, DATEFORMAT)
  item.nextBillingDate = formatDate(item?.inv_billing_next_date, DATEFORMAT)
  item.add_fee_full_pay = item.add_fee_full_pay === 1
  item.add_fee_installment_pay = item.add_fee_installment_pay === 1
  item.payment_type = item.inv_installment_count <= 1 ? 'Full-Payment' : 'Subscription'
}

const modifyDashboardEnrollment = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.progress = Number(item.progress)
  item.expiry_date = formatDate(item.expiry_date, DATEFORMAT)
  item.enr_end_date = formatDate(item.enr_end_date, DATEFORMAT)
  item.enr_enrolled_on = formatDate(item.enr_enrolled_on, DATEFORMAT)
  item.lastLoginTimeLabel = formatDate(item.enr_last_login_time, DATEFORMAT)
  item.enr_graduation_date = formatDate(item?.enr_graduation_date, DATEFORMATWITHTIME)
  item.updatedPgmTimeLabel = formatDate(item.pgm_end_date, DATEFORMATWITHTIME)
  item.paidAmount = ((Number(item.total_amount) || 0) - (Number(item.dueAmount) || 0)).toFixed(2)
  item.dueAmount = item.dueAmount === 0 ? '0.00' : item.dueAmount
  item.disableDrop = DROP_ENROLLMENT_LOCK_STATUSES.includes(item.enr_status)
  item.disableLMSAccess =
    LOCK_COURSES_ENROLLMENT_STATUSES.includes(item.enr_status) ||
    LOCK_COURSES_HOLD_STATUSES.includes(item.enr_hold) ||
    item.enr_status === 'processing_payment' ||
    item.enr_status === COURSE_STATUS.UPCOMING
  item.disableTranscriptAccess =
    LOCK_TRANSCRIPT_ENROLLMENT_STATUSES.includes(item.enr_status) ||
    LOCK_TRANSCRIPT_HOLD_STATUSES.includes(item.enr_hold)
  if (!isNullOrEmpty(item?.enr_active_invoice)) {
    item.enr_active_invoice.inv_billing_next_date = formatDate(
      item?.enr_active_invoice?.inv_billing_next_date,
      DATEFORMAT
    )
  }
}

const modifyEnrollItem = function (item) {
  if (isEmpty(item)) {
    return
  }
  const termCompletedCr = item?.enr_enrollment_course?.length
    ? item.enr_enrollment_course
        ?.filter(
          (values) =>
            (values.enc_status === 'passed' || values.enc_status === 'passed_without_grade') &&
            item.enr_current_grade === values.enc_grade_level
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0
  const termAssignedCr = item?.enr_enrollment_course?.length
    ? item.enr_enrollment_course
        ?.filter(
          (values) =>
            (values.enc_state === 'assign' || values.enc_state === 'plan') &&
            values.enc_status !== 'in_review' &&
            values.enc_status !== 'in_complete' &&
            values.enc_status !== 'withdrawn' &&
            item.enr_current_grade === values.enc_grade_level
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0
  const courseCompletedCr = item?.enr_enrollment_course?.length
    ? item.enr_enrollment_course
        ?.filter(
          (values) => values.enc_status === 'passed' || values.enc_status === 'passed_without_grade'
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0
  const courseAssignedCr = item?.enr_enrollment_course?.length
    ? item.enr_enrollment_course
        ?.filter(
          (values) =>
            (values.enc_state === 'assign' || values.enc_state === 'plan') &&
            values.enc_status !== 'in_review' &&
            values.enc_status !== 'in_complete' &&
            values.enc_status !== 'withdrawn'
        )
        .reduce((acc, course) => acc + Number(course.enc_credits), 0)
    : 0

  const requiredCourseForReenroll = item?.enr_enrollment_course?.filter(
    (cg) =>
      cg.enc_status === COURSE_STATUS.PASSED ||
      cg.enc_status === COURSE_STATUS.PASSED_WITHOUT_GRADE ||
      cg.enc_status === COURSE_STATUS.IN_COMPLETE ||
      cg.enc_status === COURSE_STATUS.WITHDRAWN ||
      cg.enc_status === COURSE_STATUS.FAILED
  )
  item.progress = Number(item.progress)
  item.termCompletedCourses = termCompletedCr
  item.termAssignedCourses = termAssignedCr
  item.courseCompletedCourses = courseCompletedCr
  item.courseAssignedCourses = courseAssignedCr
  item.enr_term_progress = Number(item.enr_term_progress)
  item.expiry_date = formatDate(item.expiry_date, DATEFORMAT)
  item.enr_end_date = formatDate(item.enr_end_date, DATEFORMAT)
  item.enr_enrolled_on = formatDate(item.enr_enrolled_on, DATEFORMAT)
  item.lastLoginTimeLabel = formatDate(item.enr_last_login_time, DATEFORMAT)
  item.enr_graduation_date = formatDate(item.enr_graduation_date, DATEFORMATWITHTIME)
  item.updatedPgmTimeLabel = formatDate(item.pgm_end_date, DATEFORMATWITHTIME)
  item.paidAmount = ((Number(item.total_amount) || 0) - (Number(item.dueAmount) || 0)).toFixed(2)
  item.dueAmount = item.dueAmount === 0 ? '0.00' : item.dueAmount
  item.pendingReEnrollment = (item.enr_re_enrollment || []).filter(
    (options) => options.re_enr_status === 'pending'
  )
  item.acceptedReEnrollment = (item.enr_re_enrollment || []).filter(
    (options) => options.re_enr_status === 'accepted'
  )
  item.enableReEnroll =
    item.total_course > 0 &&
    requiredCourseForReenroll.length === item.total_course &&
    item?.pendingReEnrollment?.length === 0 &&
    item?.acceptedReEnrollment?.length === 0
  if (item?.enr_program?.pgm_grade_level) {
    set(
      item,
      'enr_program.pgm_grade_level',
      sortGradeLevelArray(JSON.parse(item?.enr_program?.pgm_grade_level || '{}'))
    )
  }

  if (!isNullOrEmpty(item?.enr_active_invoice)) {
    item.enr_active_invoice.inv_billing_next_date = formatDate(
      item?.enr_active_invoice?.inv_billing_next_date,
      DATEFORMAT
    )
  }
  item.disableLMSAccess =
    LOCK_COURSES_ENROLLMENT_STATUSES.includes(item.enr_status) ||
    LOCK_COURSES_HOLD_STATUSES.includes(item.enr_hold) ||
    item.enr_status === 'processing_payment' ||
    item.enr_status === COURSE_STATUS.UPCOMING

  item.disableTranscriptAccess =
    LOCK_TRANSCRIPT_ENROLLMENT_STATUSES.includes(item.enr_status) ||
    LOCK_TRANSCRIPT_HOLD_STATUSES.includes(item.enr_hold)
  item.disableDrop = DROP_ENROLLMENT_LOCK_STATUSES.includes(item.enr_status)
  item.remaining_installments =
    Number(item.enr_active_invoice?.inv_installment_count || 0) -
    (Number(item.enr_active_invoice?.inv_installment_paid || 0) +
      Number(item.enr_active_invoice?.inv_prepaid_installment || 0))
}

const modifySuccessCoach = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.sc_assigned_date = formatDate(item.sc_assigned_date, DATEFORMATWITHTIME)
}

export const fetchAddOnsCheckoutListCall =
  (pageDetails, successCallback, failureCallback) => async () => {
    try {
      let filterQuery = `districtId=${pageDetails.districtId || ''}&schoolId=${
        pageDetails.schoolId || ''
      }&programId=${pageDetails.programId || ''}&q=${pageDetails.q || ''}&perPage=1000`
      if (pageDetails.purchaseFrom) {
        filterQuery += `&purchaseFrom=${moment(pageDetails.purchaseFrom).format(
          'YYYY-MM-DD'
        )}T00:00:00`
      }
      if (pageDetails.purchaseTo) {
        filterQuery += `&purchaseTo=${moment(pageDetails.purchaseTo).format('YYYY-MM-DD')}T23:59:59`
      }
      if (pageDetails.enrollmentId) {
        filterQuery += `&enrollmentId=${pageDetails?.enrollmentId}`
      }

      const apiPath = `${API.CORE.ADD_ONS_LISTING}?${filterQuery}`
      const { data } = await fetch(apiPath, {})
      get(data, 'content', []).forEach((item) => modifyAddOnsServiceData(item))
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (err) {
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

const modifyProgramItem = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.pgm_program_course_group = item.pgm_program_course_group.map(
    (pgm_program_course_group_item) => ({
      ...pgm_program_course_group_item,
      id: pgm_program_course_group_item.cg_id.toString(),
      cg_course_group_item: pgm_program_course_group_item.cg_course_group_item.map(
        (cg_course_group_item) => ({
          ...cg_course_group_item,
          isSelected: !cg_course_group_item.cgi_is_elective,
          id: cg_course_group_item.cgi_id.toString(),
        })
      ),
      // cg_rule_value:
      //   pgm_program_course_group_item.cg_rule_type === RULE_TYPES.MIN_MAX_COURSE
      //     ? pgm_program_course_group_item.cg_rule_value
      //       ? pgm_program_course_group_item.cg_rule_value.split('.')
      //       : [0, 0]
      //     : pgm_program_course_group_item.cg_rule_value,
    })
  )
  item.pgm_grade_level = sortGradeLevelArray(item.pgm_grade_level)
  item.updatedPgmTimeLabel = formatDate(item.pgm_end_date, DATEFORMATWITHTIME)
}

const modifyDropEnrollment = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.id = item.end_id
  item.created_at = formatDate(item.created_at, DATEFORMATWITHTIME)
  item.updated_at = formatDate(item.updated_at, DATEFORMATWITHTIME)
  item.end_payment_arr = !isNullOrEmpty(item?.end_payment)
    ? (item?.end_payment || []).split(',')
    : []
  item.end_reason_arr = !isNullOrEmpty(item?.end_reason) ? item?.end_reason.split(',') : []
  item.end_admin_student_reason_arr = !isNullOrEmpty(item?.end_admin_student_reason)
    ? item?.end_admin_student_reason.split(', ')
    : []

  item.end_request_type_arr = !isNullOrEmpty(item?.end_request_type)
    ? item?.end_request_type.split(',')
    : []
}

const modifyReEnrollment = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.id = item.re_enr_id
  item.created_at = formatDate(item.created_at, DATEFORMAT)
  item.tentativeDate = formatDate(item?.re_enr_tentative_date, DATEFORMAT)
  item.lastEnrolledDate = formatDate(item?.enrollment?.enr_enrolled_on, DATEFORMAT)
  item.updated_at = formatDate(item.updated_at, DATEFORMAT)
  item.studentName = item?.student ? getFullName(item.student) : ''
}

const modifyReEnrollmentElective = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.cgi = item.cgi.map((cgi) => ({
    ...cgi,
    isSelected: !cgi.cgi_is_elective,
    id: cgi.cgi_id.toString(),
  }))
  return item
}

const modifyQuizSubmissons = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.percentage = !isNullOrEmpty(item?.score) && getPercentage(item?.score, item?.possible_pt)
}

const checkForTypes = (key, value) => {
  if (value === '1') {
    return true
  } else if (value === '0') {
    return false
  } else {
    return value
  }
}

const sortGradeLevelArray = (data) => {
  // Remove 'AHS' and 'CLG' from the data array
  const filteredArray = data.filter((item) => item !== 'AHS' && item !== 'CLG')
  // Sort the filtered array numerically
  filteredArray.sort((a, b) => parseInt(a) - parseInt(b))
  // Find the index of 'AHS' and 'CLG' if present
  const ahsIndex = data.indexOf('AHS')
  const clgIndex = data.indexOf('CLG')
  // Insert 'AHS' at the last index if it exists
  if (ahsIndex !== -1) {
    filteredArray.push('AHS')
  }
  // Insert 'CLG' at the last index if it exists
  if (clgIndex !== -1) {
    filteredArray.push('CLG')
  }

  return filteredArray
}

const modifyCourses = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.enc_course_completed =
    item.enc_course_completed === 1
      ? true
      : item.enc_course_completed === 0
      ? false
      : item.enc_course_completed
}

const modifyAddOnsServiceData = function (item) {
  if (isEmpty(item)) {
    return
  }
  item.createdTimeLabel = formatDate(item?.created_at, DATEFORMATWITHTIME)
  item.updatedTimeLabel = formatDate(item?.updated_at, DATEFORMATWITHTIME)
  item.purchase_at = formatDate(item?.purchase_at, DATEFORMATWITHTIME)
}
